module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-flow-1-5c777c4e06da00aca71527faff6350f2.png";